// extracted by mini-css-extract-plugin
module.exports = {"userManagement":"UserManagement_userManagement__3aSU3","searchBox":"UserManagement_searchBox__MgwQP"};